import { useCallback } from 'react'
import styled from 'styled-components'
import { UnmatchedItem } from '../../types/catalogReview'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Button } from '../../components/ui/Button'
import { tokens } from '../../styles/tokens'

const Text = styled.div`
  font-weight: 500;
  color: ${tokens.purple900};
`

const Muted = styled.div`
  font-size: 12px;
  color: ${tokens.purple400};
  margin-top: 2px;
`

interface Props {
  item: UnmatchedItem
  onReview: (item: UnmatchedItem) => void
}

export function UnmatchedRow({ item, onReview }: Props) {
  const handleReview = useCallback(() => onReview(item), [item, onReview])
  const otherSpellings = item.variants.filter(v => v !== item.text)

  return (
    <TR>
      <TD>
        <Text>{item.text}</Text>
        {otherSpellings.length > 0 && <Muted>also: {otherSpellings.join(', ')}</Muted>}
      </TD>
      <TD>
        {item.recipeCount} {item.recipeCount === 1 ? 'recipe' : 'recipes'}
        <Muted>{item.recipes.map(r => r.name).join(' · ')}</Muted>
      </TD>
      <TD>{new Date(item.firstSeen).toLocaleDateString()}</TD>
      <ActionsCell>
        <Button size="sm" onClick={handleReview}>
          Review
        </Button>
      </ActionsCell>
    </TR>
  )
}
